import {
  COLOR_INQUIRY_STATUS,
  COLOR_INQUIRY_TYPE,
  HEXCOLOR_INQUIRY_STATUS,
  INQUIRY_STATUS,
  INQUIRY_TYPE,
  getPlatFormImage,
} from "helpers/constans";
import { formatDateStringToKorea } from "helpers/format";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { Card, Col, Container, Label, Row } from "reactstrap";
import avatar1 from "../../../../assets/images/users/ic_defaul_avatar2.png";
import ModalPreview from "components/Common/ModalPreview";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import { capitalizeFirstLetter, secondsToDhms } from "utils";
import { Button, Dropdown, Menu, Select } from "antd";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import inquiryListApi from "api/inquiryListApi";
import CopyWrapper from "components/Common/CopyWrapper";
import ProfileIcon from "../../../../assets/images/Profile.png";
import ContactIcon from "../../../../assets/images/phone-icon.png";
import countries from "helpers/countries";
import { DownOutlined } from "@ant-design/icons";

const Overview = ({ data, reloadData }: any) => {
  const { t, i18n } = useTranslation();
  const [linkImage, setLinkImage] = useState<any>(null);

  const countryCode = data?.device_info?.country_code;
  const country = countries.find((item) => item?.code == countryCode) || {
    name_korea: data?.device_info?.country,
    name: data?.device_info?.country,
    flags: "",
  };

  useEffect(() => {
    document.title = `${t("Overview")} - ${t("Bar Detail")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  let platform = data?.account_info?.platform;
  let imgPlatform = getPlatFormImage(platform);
  if (platform === "default") {
    platform = "Email";
  }

  async function handleUpdateInquiry(value: any) {
    if (value == data?.status) return;
    try {
      const response: any = await inquiryListApi?.updateInquiry(data?.id, {
        status: value,
      });
      console.log(response);
      if (response?.code == 200) {
        reloadData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  let inquiry_status_condition = [...INQUIRY_STATUS];
  if (data?.status == 2)
    inquiry_status_condition = [
      INQUIRY_STATUS[1],
      INQUIRY_STATUS[2],
      INQUIRY_STATUS[3],
    ];
  if (data?.status == 3)
    inquiry_status_condition = [INQUIRY_STATUS[2], INQUIRY_STATUS[3]];

  const menu = (
    <Menu onClick={(e) => handleUpdateInquiry(Number(e.key))}>
      {inquiry_status_condition.map((status) => (
        <Menu.Item key={status?.value}>{t(status?.label)}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <React.Fragment>
      <div className="mt-3">
        <Row>
          <div className="d-flex gap-5 align-items-center">
            <div className="mb-3 d-flex gap-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Inquiry Type")}
              </Label>
              <div>
                <span
                  className={`rounded-pill badge bg-${
                    COLOR_INQUIRY_TYPE[data?.type] || "secondary"
                  }`}
                >
                  {t(
                    INQUIRY_TYPE?.find(
                      (i: any) => String(i?.value) === String(data?.type)
                    )?.label || ""
                  )}
                </span>
              </div>
            </div>

            <div className="mb-3 d-flex gap-3 align-items-center">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Inquiry Status")}
              </Label>
              <div>
                {/*  <span
                  className={`rounded-pill badge bg-${
                    COLOR_INQUIRY_STATUS[data?.status] || "secondary"
                  }`}
                >
                  {t(
                    INQUIRY_STATUS?.find(
                      (i: any) => String(i?.value) === String(data?.status)
                    )?.label || ""
                  )}
                </span> */}

                <Dropdown overlay={menu} trigger={["click"]}>
                  <Button
                    style={{
                      backgroundColor: HEXCOLOR_INQUIRY_STATUS[data?.status],
                      color: "white",
                      borderRadius: "25px",
                      padding: "6px 16px",
                    }}
                    disabled={data?.status == 1 || data?.status == 4}
                  >
                    {t(
                      INQUIRY_STATUS?.find(
                        (i: any) => String(i?.value) === String(data?.status)
                      )?.label || ""
                    )}
                    {data?.status != 1 && data?.status != 4 && <DownOutlined />}
                  </Button>
                </Dropdown>

                {/* <Select
                  value={INQUIRY_STATUS?.find(
                    (i: any) => String(i?.value) === String(data?.status)
                  )}
                  style={{ width: 120 }}
                  onChange={handleUpdateInquiry}
                  options={INQUIRY_STATUS}
                  dropdownStyle={{ borderRadius: "8px" }}
                /> */}
              </div>

              <div style={{ fontSize: 11 }}>
                {!data?.processing_time_expired &&
                  data?.process_time_elapsed && <>{t("Timelapsed")} </>}
                {data?.processing_time_expired &&
                  data?.process_time_elapsed && <>{t("Overdue")} </>}
                {secondsToDhms(
                  data?.processing_time_expired || data?.process_time_elapsed,
                  t
                )}
              </div>
            </div>

            <div className="mb-3 d-flex gap-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Inquiry Date")}
              </Label>
              <div>
                {formatDateStringToKorea(
                  data?.created_at,
                  "YYYY-MM-DD HH:mm"
                ) || "-"}
              </div>
            </div>
          </div>

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Content")}
              </Label>
              <div style={{ whiteSpace: "pre-line" }}>
                {data?.contents ? (
                  <CopyWrapper
                    contentCopy={data?.contents}
                  >{`${data?.contents}`}</CopyWrapper>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </Col>

          <div className="d-flex gap-4 flex-wrap">
            <Card
              className="p-3"
              style={{ minWidth: 300, background: "#F7F7F7" }}
            >
              <h5 className="mb-3 d-flex align-items-center gap-2">
                <img src={ProfileIcon} /> {t("Account")}
              </h5>
              <div>
                <div className="mb-3 d-flex gap-3 align-items-center">
                  <div className="text-center ">
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        setLinkImage(
                          (prev: any) => data?.account_info?.avatar ?? avatar1
                        )
                      }
                    >
                      <img
                        src={data?.account_info?.avatar ?? avatar1}
                        className="rounded-circle avatar-sm"
                        alt="thumbnail"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = avatar1;
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <div className="mb-1" style={{ fontWeight: 700 }}>
                      {data?.account_info?.nickname ? (
                        <CopyWrapper
                          contentCopy={data?.account_info?.nickname}
                        >{`${data?.account_info?.nickname}`}</CopyWrapper>
                      ) : (
                        "-"
                      )}
                    </div>

                    <div style={{ color: "#555555" }}>
                      {data?.account_info?.email ? (
                        <CopyWrapper
                          contentCopy={data?.account_info?.email}
                        >{`${data?.account_info?.email}`}</CopyWrapper>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-5">
                  <div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Platform")}:
                      </Label>
                      <div className="d-flex flex-column gap-1">
                        <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                          <div style={{ width: "25px" }}>
                            {imgPlatform && platform !== "-" && (
                              <img
                                src={imgPlatform}
                                width={25}
                                height={25}
                                alt="platform"
                              />
                            )}
                          </div>
                          <div className="cursor-pointer">
                            {t(capitalizeFirstLetter(platform))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("App Version")}:
                      </Label>
                      <div>
                        {data?.device_info?.app_version ? (
                          <CopyWrapper
                            contentCopy={data?.device_info?.app_version}
                          >{`${data?.device_info?.app_version}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("IP")}:
                      </Label>
                      <div>
                        {data?.device_info?.ip ? (
                          <CopyWrapper
                            contentCopy={data?.device_info?.ip}
                          >{`${data?.device_info?.ip}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>{" "}
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Country")}:
                      </Label>
                      <div className="cursor-pointer d-flex gap-2 align-items-center justify-content-center">
                        {country && (
                          <>
                            {countryCode && (
                              <img
                                src={country?.flags}
                                width={20}
                                height={20}
                                alt="profile"
                              />
                            )}
                            <div className="cursor-pointer">
                              {i18n?.language === "ko"
                                ? country?.name_korea
                                : country?.name}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Model")}:
                      </Label>
                      <div>
                        {data?.device_info?.model ? (
                          <CopyWrapper
                            contentCopy={data?.device_info?.model}
                          >{`${data?.device_info?.model}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Manufacturer")}:
                      </Label>
                      <div>
                        {data?.device_info?.manufacturer ? (
                          <CopyWrapper
                            contentCopy={data?.device_info?.manufacturer}
                          >{`${data?.device_info?.manufacturer}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>

                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("UUID")}:
                      </Label>
                      <div>
                        {data?.account_info?.uuid ? (
                          <CopyWrapper
                            contentCopy={data?.account_info?.uuid}
                          >{`${data?.account_info?.uuid}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Address")}:
                      </Label>
                      <div>
                        {data?.device_info?.address ? (
                          <CopyWrapper
                            contentCopy={data?.device_info?.address}
                          >{`${data?.device_info?.address}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <div>
              <Card
                className="p-3"
                style={{
                  minWidth: 300,
                  background: "#F7F7F7",
                  height: "fit-content",
                }}
              >
                <h5 className="mb-3 d-flex align-items-center gap-2">
                  <img src={ContactIcon} />
                  {t("Contact")}
                </h5>

                <div className="mb-3 d-flex gap-2 align-items-center">
                  <Label htmlFor="name-bar" className="form-label m-0">
                    {t("Contact Name")}:
                  </Label>
                  <div>
                    {data?.contact_info?.contact_name ? (
                      <CopyWrapper
                        contentCopy={data?.contact_info?.contact_name}
                      >{`${data?.contact_info?.contact_name}`}</CopyWrapper>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="mb-3 d-flex gap-2 align-items-center">
                  <Label htmlFor="name-bar" className="form-label m-0">
                    {t("Contact Phone")}:
                  </Label>
                  <div>
                    {data?.contact_info?.contact_phone ? (
                      <CopyWrapper
                        contentCopy={data?.contact_info?.contact_phone}
                      >{`${data?.contact_info?.contact_phone}`}</CopyWrapper>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="mb-3 d-flex gap-2 align-items-center">
                  <Label htmlFor="name-bar" className="form-label m-0">
                    {t("Contact Email")}:
                  </Label>
                  <div>
                    {data?.contact_info?.contact_email ? (
                      <CopyWrapper
                        contentCopy={data?.contact_info?.contact_email}
                      >{`${data?.contact_info?.contact_email}`}</CopyWrapper>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Card>
              {data?.rating && (
                <Card
                  className="p-3"
                  style={{
                    minWidth: 300,
                    background: "#F7F7F7",
                    height: "fit-content",
                  }}
                >
                  <h5 className="mb-3">{t("Rating")}</h5>

                  <div className="mb-3 d-flex gap-2 align-items-center">
                    <div>{data?.rating || "-"}</div>
                  </div>
                  <div className="mb-3 d-flex gap-2 align-items-center">
                    <Label htmlFor="name-bar" className="form-label m-0">
                      {t("Rating Date")}
                    </Label>
                    <div>{data?.rating_date || "-"}</div>
                  </div>
                  <div className="mb-3 d-flex gap-2 align-items-center">
                    <Label htmlFor="name-bar" className="form-label m-0">
                      {t("Content")}
                    </Label>
                    <div>{data?.rating_content || "-"}</div>
                  </div>
                </Card>
              )}
            </div>
          </div>

          {data?.attachments?.length > 0 && (
            <div className="mb-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Attachment")}:
              </Label>
              <div className="d-flex gap-3 flex-wrap">
                {data?.attachments?.map((i: any) => {
                  if (i?.type == "video")
                    return (
                      <video width="160" height="120" controls key={i?.path}>
                        <source src={i?.path} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    );

                  if (i?.type == "image")
                    return (
                      <div>
                        <div
                          style={{ width: "90px" }}
                          className="cursor-pointer"
                          onClick={() => {
                            // if (data?.attachments?.length > 1) {
                            //   setLinkImage({
                            //     urls: data?.attachments?.map((i: any) => {
                            //       return { ...i, url: i?.path };
                            //     }),
                            //     keyword: {
                            //       title: data?.filename,
                            //       keyword: data?.filename,
                            //     },
                            //   });
                            // }
                            setLinkImage(i?.path);
                            document.body.className = "modal-open_img";
                          }}
                        >
                          <img
                            src={i?.path}
                            className="flex-shrink-0 rounded w-100"
                            alt="thumbnail"
                          />
                        </div>
                      </div>
                    );
                  return (
                    <div
                      style={{
                        minWidth: 150,
                        height: 120,
                        background: "#F7F7F7",
                        padding: 20,
                        borderRadius: 6,
                      }}
                    >
                      <a href={i?.path}>{i?.filename}</a>
                    </div>
                  );
                }) || "-"}
              </div>
            </div>
          )}
        </Row>
      </div>

      <ModalPreview
        type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
        isOpen={!!linkImage}
        url={linkImage}
        content={linkImage?.content}
        onClose={() => setLinkImage(null)}
      />

      <ModalMultiPreview
        isOpen={!!linkImage?.urls}
        urls={linkImage?.urls || []}
        content={linkImage?.content}
        onClose={() => setLinkImage(null)}
      />
    </React.Fragment>
  );
};

export default Overview;
